// Extrait du proto Modules/12M Cash/treso_v9.jsx (lignes 249-282).
// VERBATIM — 4 modes de driver : pct_ca_total, pct_ca_ligne, manuel, direct.

export const computeVariableValeurs = (charge, revenus) => {
  const valeurs = Array(12).fill(0);
  if (!charge) return valeurs;
  const revs = Array.isArray(revenus) ? revenus : [];
  if (charge.driverType === 'pct_ca_total') {
    const tauxPct = (Number(charge.taux) || 0) / 100;
    for (let m = 0; m < 12; m++) {
      const caMois = revs.reduce((acc, r) => acc + (Array.isArray(r.valeurs) ? (Number(r.valeurs[m]) || 0) : 0), 0);
      valeurs[m] = caMois * tauxPct;
    }
  } else if (charge.driverType === 'pct_ca_ligne') {
    const ligne = revs.find(r => r.id === charge.ligneRevenuId);
    if (ligne && Array.isArray(ligne.valeurs)) {
      const tauxPct = (Number(charge.taux) || 0) / 100;
      // Coût marchandise = taux × valeur marchandise (CA × goodsPct).
      // Défaut goodsPct=1 si absent (fixtures/tests) → comportement historique.
      const g = ligne.goodsPct == null ? 1 : Number(ligne.goodsPct);
      for (let m = 0; m < 12; m++) valeurs[m] = (Number(ligne.valeurs[m]) || 0) * tauxPct * g;
    }
  } else if (charge.driverType === 'manuel') {
    // Saisie mois par mois — un tableau valeurs[12] est porté par la charge
    const v = Array.isArray(charge.valeurs) ? charge.valeurs : [];
    for (let m = 0; m < 12; m++) valeurs[m] = Number(v[m]) || 0;
  } else {
    // Mode 'direct' — montant fixe avec mois cochés et mode mensuel/annuel
    const moisActifs = Array.isArray(charge.moisActifs) ? charge.moisActifs : [0,1,2,3,4,5,6,7,8,9,10,11];
    if (moisActifs.length === 0) return valeurs;
    const montant = Number(charge.montant) || 0;
    if (charge.mode === 'annuel') {
      const parMois = montant / moisActifs.length;
      moisActifs.forEach(m => { if (m >= 0 && m < 12) valeurs[m] = parMois; });
    } else {
      moisActifs.forEach(m => { if (m >= 0 && m < 12) valeurs[m] = montant; });
    }
  }
  return valeurs;
};
